<template>
  <div class="container mx-auto bg-white shadow rounded p-10 flex flex-col text-center text-gray-500">

    <div class="p-2">
      <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4" style="border-top-color:white"></div>
      <p  class="p-2 text-gray-600 font-bold">{{ title }}</p>
      <p  class="p-2 text-gray-600">{{ message }}</p>
    </div>

  </div>
</template>

<script>

export default {
  name: 'CommonLoader',
  props: {
    title: {
      type: String,
      required: false,
      default () { return 'Loading...' }
    },
    message: {
      type: String,
      required: false,
      default () { return 'This may take a few seconds, please wainting...' }

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/loader.vue